var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countdown"},_vm._l((_vm.formattedDays),function(digit,index){return _c('span',{key:index,staticClass:"digit"},[_vm._v(" "+_vm._s(digit)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }